import { CartLinesUpdateEvent } from '@shopify/events';

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('animasy-brush .an-form')) return;
  if (!document.querySelector('#cart-drawer cart-drawer-component')) return;
  event.preventDefault();
  if (form.dataset.cartPending === 'true') return;

  const body = new FormData(form);
  const sectionIds = [...new Set(Array.from(document.querySelectorAll('cart-items-component'), item => item.dataset.sectionId).filter(Boolean))].slice(0, 5);
  body.delete('return_to');
  body.set('sections', sectionIds.join(','));
  body.set('sections_url', window.location.pathname);
  const errorElement = form.querySelector('[data-cart-error]');
  const buttons = Array.from(form.elements).filter(element => element instanceof HTMLButtonElement && element.type === 'submit');
  const previousDisabled = buttons.map(button => button.disabled);
  form.dataset.cartPending = 'true';
  form.setAttribute('aria-busy', 'true');
  buttons.forEach(button => { button.disabled = true; });
  if (errorElement) { errorElement.hidden = true; errorElement.textContent = ''; }

  const update = CartLinesUpdateEvent.createPromise();
  update.promise.catch(() => {});
  form.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add',
    context: 'product',
    lines: [{ merchandiseId: String(body.get('id')), quantity: Number(body.get('quantity')) || 1 }],
    promise: update.promise,
  }));

  let added = false;
  try {
    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST', body, headers: { Accept: 'application/json' },
    });
    const result = await response.json();
    if (!response.ok || result.status) {
      const message = typeof result.description === 'string' ? result.description : errorElement?.dataset.defaultError;
      throw new Error(message);
    }
    added = true;
    const cartResponse = await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!cartResponse.ok) throw new Error();
    const cart = await cartResponse.json();
    update.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, sections: result.sections, source: 'animasy-brush', sourceId: form.id, didError: false },
    });
  } catch (error) {
    update.reject(error);
    if (added) {
      window.location.assign(Theme.routes.cart_url);
    } else if (errorElement) {
      errorElement.textContent = error.message || errorElement.dataset.defaultError;
      errorElement.hidden = false;
    }
  } finally {
    delete form.dataset.cartPending;
    form.removeAttribute('aria-busy');
    buttons.forEach((button, index) => { button.disabled = previousDisabled[index]; });
  }
});
